import React, { Fragment } from "react";
import { AuthRequiredError } from "@app/lib/errors/AuthRequiredError";
import { FOLLOW_UP } from "@app/constants/Constants";

export const pad = (number) => (number < 10 ? "0" : "") + number;

export function isObject(item) {
	return item && typeof item === "object" && !Array.isArray(item) && item !== null;
}

export const deepEqual = (obj1, obj2) => {
	if (typeof obj1 !== "object" || obj1 === null || typeof obj2 !== "object" || obj2 === null) {
		return obj1 === obj2;
	}

	const keys1 = Object.keys(obj1);
	const keys2 = Object.keys(obj2);

	if (keys1.length !== keys2.length) {
		return false;
	}

	for (const key of keys1) {
		if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
			return false;
		}
	}

	return true;
};

export function deepSearch(object, key, predicate) {
	if (object.hasOwnProperty(key) && predicate(key, object[key]) === true) return object;

	for (let i = 0; i < Object.keys(object).length; i++) {
		let value = object[Object.keys(object)[i]];
		if (typeof value === "object" && value != null) {
			let o = deepSearch(object[Object.keys(object)[i]], key, predicate);
			if (o != null) return o;
		}
	}
	return null;
}

export const nl2br = (text) => {
	if (text) {
		return text.split("\n").map((item, key) => (
			<Fragment key={key}>
				{item}
				<br />
			</Fragment>
		));
	}
};

export const formatDate = (dateString) => {
	const options = { day: "2-digit", month: "2-digit", year: "numeric" };
	return new Intl.DateTimeFormat("de-DE", options).format(new Date(dateString));
};

export const authMiddleware = async (response) => {
	return new Promise((resolve, reject) => {
		if (!response.ok && response.status === 403) {
			const path = window.location.pathname;
			setTimeout(() => {
				console.log("authMiddleware 403", path);
				// window.location.href = `${Config.API.BASE_PATH}/auth`;
			}, 0);
			reject(new AuthRequiredError(path));
		} else {
			resolve();
		}
	});
};

const getCookie = (name) =>
	document.cookie
		.split("; ")
		.find((r) => r.startsWith(name + "="))
		?.split("=")[1];

const clearRedirectCookie = () => (document.cookie = "redirectTo=; Path=/; Max-Age=0; SameSite=Lax");

export const useAuthRedirect = (enabled = true) => {
	// const navigate = useNavigate();
	const cookieTarget = getCookie("redirectTo") ? decodeURIComponent(getCookie("redirectTo")) : null;

	// const target = cookieTarget || fromState || "/";
	const referrer = document.referrer.replace(/\/+$/, "");
	const origin = window.location.origin.replace(/\/+$/, "");
	if (cookieTarget && enabled && !referrer.startsWith(origin)) {
		clearRedirectCookie();
		window.location.href = cookieTarget;
		return {
			pendingRedirect: true,
		};
	}

	return {
		pendingRedirect: false,
	};
};

export function getDayDiff(datetimeStamp) {
	const today = new Date(new Date().setHours(0, 0, 0, 0));
	const targetDate = new Date(new Date(datetimeStamp).setHours(0, 0, 0, 0));
	const diff = (targetDate - today) / (1000 * 60 * 60 * 24);
	return diff;
}

const parseKey = (str) => {
	const key = str.split(" ")[0]; // alles vor erstem Leerzeichen

	const match = key.match(/^([A-Z]+)(.+)$/i);
	if (!match) return { letters: key, numbers: [] };

	const [, letters, rest] = match;

	const numbers = rest.split(".").map((n) => parseInt(n, 10));

	return { letters, numbers };
};

export const compareMeasureLabels = (a, b) => {
	const pa = parseKey(a);
	const pb = parseKey(b);

	// 1. Buchstaben vergleichen
	if (pa.letters !== pb.letters) {
		return pa.letters.localeCompare(pb.letters);
	}

	// 2. Zahlen hierarchisch vergleichen
	const len = Math.max(pa.numbers.length, pb.numbers.length);

	for (let i = 0; i < len; i++) {
		const na = pa.numbers[i];
		const nb = pb.numbers[i];

		// kürzere Struktur kommt zuerst
		if (na === undefined) return -1;
		if (nb === undefined) return 1;

		if (na !== nb) return na - nb;
	}

	return 0;
};
export const filterElements = (element, type) => {
	const notFollowUp = type !== FOLLOW_UP && element.elementType !== "followUp";
	const isFollowUp = type === FOLLOW_UP;
	return !["headline", "subHeadline"].includes(element.elementType) && (notFollowUp || isFollowUp);
};
